import {useNavigate} from "react-router-dom"
import {useEffect} from "react"
export const LogOut=()=>{
    const navigate=useNavigate()
    useEffect(()=>
        navigate("/")
    ,[])
    
    return null
}